import axios, { CustomParamsSerializer, ParamsSerializerOptions } from "axios";
import qs from "qs";
import { setupInterceptors } from "./interceptors";

const paramsSerializer = (
  params: ParamsSerializerOptions | CustomParamsSerializer
) => qs.stringify(params, { arrayFormat: "brackets", skipNulls: true });

const createAxiosClient = (baseURL: string) => {
  const instance = axios.create({
    baseURL,
    // timeout: 10000,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    paramsSerializer,
  });

  return setupInterceptors(instance);
};

export default createAxiosClient;
